export var datePickerOptions = {
  firstDayOfWeek: 1
};